
import Vue from "vue";
import dialogCom from "@/components/ModelCom.vue";
import action from "@/components/ActionBarCom.vue";
import Utils from "@/assets/js/Utils";
import HttpUtil from "@/assets/js/HttpUtil";
import Urls from "@/assets/js/Urls";
import { StoreTypes } from "@/assets/js/Types";
export default Vue.extend({
  components: { action, dialogCom },
  data() {
    return {
      items: [] as any[],
      choosedItem: [] as any[],
      project: null as any,
      current: null as any,
      form: {
        videoSubUrl: "",
      } as any,
    };
  },
  mounted() {
    const project = this.$store.state.project[StoreTypes.XC_PROJECT_CURRENT];
    this.form.videoSubUrl = project.videoSubUrl;
    console.log(project);
    this.getList();
  },
  methods: {
    currentChange(val: any) {
      this.current = val;
    },
    handleSelectionChange(val: any) {
      this.choosedItem = [];
      val.forEach((x: any) => {
        this.choosedItem.push(x.sid);
      });
    },
    async getAlarmTypes() {
      const ret: any = await HttpUtil.XCHttpPost(
        Urls.GetAlarmTypes,
        this.CSID,
        true,
        false
      );
      this.items = ret.filter((x: any) => x.canSub == 1);
    },
    async getList() {
      await this.getAlarmTypes();
    },
    closeDialog() {
      const dialog: any = this.$refs.dialog;
      dialog.hiden();
    },
    async submit() {
      const req = {
        subUrl: this.form.videoSubUrl,
        alarmIds: this.choosedItem,
      };
      const ret: any = await HttpUtil.XCHttpPost(Urls.SubAiAlarm, req, true, false);
      this.closeDialog();
      window.setTimeout(() => {
        this.getList();
      }, 3000);
    },
    downAi() {
      if (!this.choosedItem || this.choosedItem.length == 0) {
        throw "请选择需要订阅的AI场景";
      }
      const dialog: any = this.$refs.dialog;
      dialog.show();
    },
  },
});
